<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="my-xl mx">

  <well-action-inputs #actionForm
                      [action]="action"
                      [meta]="meta"
                      [subscriptionTypeUuid]="subscriptionTypeUuid"
                      (save)="onActionSubmit($event)" data-testid="action-inputs-input">

  </well-action-inputs>

  <div class="mt pull-right">
    <button pButton [label]="'company.utils.cancel' | translate" type="button"
            class="mr-sm flat p-button-text" (click)="this.goBack()" data-testid="go-back-btn"></button>
    <button pButton [label]="'company.utils.save' | translate" type="submit"
            (click)="actionForm.onSubmit()" [disabled]="!actionForm.form.valid" data-testid="action-form-on-submit-btn"></button>
  </div>
</div>


